import { useGetList } from 'ra-core';
import { useEffect, useState } from 'react';
import { SecurityInventoryItem } from '@x-guard/xgac-types/xgac';
import { Identifier } from 'react-admin';
import { InventoryItemsLayout } from './components/InventoryItemsLayout';
import { InventoryItemsMap } from './components/InventoryItemsMap';
import { InventoryItemsSidebar } from './components/InventoryItemsSidebar';
import { securityInventoryCategoriesResource, securityItemsResource } from './util';

export const InventoryItemsList = () => {

  const { data: itemsData, isLoading: itemsLoading } = useGetList(securityItemsResource, {
    pagination: { page: 1, perPage: -1 },
    sort: { field: 'name', order: 'ASC' },
    filter: {},
  });

  const { data: categoriesData } = useGetList(securityInventoryCategoriesResource, {
    pagination: { page: 1, perPage: -1 },
    sort: { field: 'name', order: 'ASC' },
    filter: {},
  });

  const [filteredItems, setFilteredItems] = useState<SecurityInventoryItem[]>([]);
  const [map, setMap] = useState<L.Map | null>(null);
  const [focusedItemId, setFocusedItemId] = useState<Identifier | null>(null);
  const [hoveredItemId, setHoveredItemId] = useState<Identifier | null>(null);

  useEffect(() => {

    setFilteredItems(itemsData ?? []);

  }, [itemsData]);

  return (
    <InventoryItemsLayout
      map={<InventoryItemsMap
        mapRef={setMap}
        items={filteredItems}
        itemsLoading={itemsLoading}
        categories={categoriesData || []}
        focusedItemId={focusedItemId}
        hoveredItemId={hoveredItemId}
        setFocusedItemId={setFocusedItemId}
      />}
      sidebar={
        <InventoryItemsSidebar
          itemsData={itemsData || []}
          itemsLoading={itemsLoading}
          categoriesData={categoriesData || []}
          setFilteredItems={setFilteredItems}
          map={map}
          focusedItemId={focusedItemId}
          hoveredItemId={hoveredItemId}
          setHoveredItemId={setHoveredItemId}
          setFocusedItemId={setFocusedItemId}
        />}
    />
  );

};
